export const BUY_ITEMS = {
    rifles: [
        { id: 'ak47', name: 'AK-47', price: 2700 },
        { id: 'm4a1', name: 'M4A4', price: 3000 },
        { id: 'm4a1_silencer', name: 'M4A1-S', price: 2900 },
        { id: 'galilar', name: 'Galil AR', price: 1800 },
        { id: 'famas', name: 'FAMAS', price: 2050 },
        { id: 'awp', name: 'AWP', price: 4750 },
        { id: 'ssg08', name: 'SSG 08', price: 1700 },
        { id: 'aug', name: 'AUG', price: 3300 },
        { id: 'sg556', name: 'SG 553', price: 3000 },
    ],
    pistols: [
        { id: 'glock', name: 'Glock-18', price: 200 },
        { id: 'usp_silencer', name: 'USP-S', price: 200 },
        { id: 'hkp2000', name: 'P2000', price: 200 },
        { id: 'p250', name: 'P250', price: 300 },
        { id: 'deagle', name: 'Desert Eagle', price: 700 },
        { id: 'revolver', name: 'R8 Revolver', price: 600 },
        { id: 'fiveseven', name: 'Five-SeveN', price: 500 },
        { id: 'tec9', name: 'Tec-9', price: 500 },
        { id: 'cz75a', name: 'CZ75-Auto', price: 500 },
        { id: 'elite', name: 'Dual Berettas', price: 300 },
    ],
    smgs: [
        { id: 'mac10', name: 'MAC-10', price: 1050 },
        { id: 'mp9', name: 'MP9', price: 1250 },
        { id: 'mp7', name: 'MP7', price: 1500 },
        { id: 'ump45', name: 'UMP-45', price: 1200 },
        { id: 'p90', name: 'P90', price: 2350 },
        { id: 'bizon', name: 'PP-Bizon', price: 1400 },
        { id: 'mp5sd', name: 'MP5-SD', price: 1500 },
    ],
    heavy: [
        { id: 'nova', name: 'Nova', price: 1050 },
        { id: 'xm1014', name: 'XM1014', price: 2000 },
        { id: 'mag7', name: 'MAG-7', price: 1300 },
        { id: 'sawedoff', name: 'Sawed-Off', price: 1100 },
        { id: 'm249', name: 'M249', price: 5200 },
        { id: 'negev', name: 'Negev', price: 1700 },
    ],
    grenades: [
        { id: 'flashbang', name: 'Flashbang', price: 200 },
        { id: 'smokegrenade', name: 'Smoke Grenade', price: 300 },
        { id: 'hegrenade', name: 'HE Grenade', price: 300 },
        { id: 'molotov', name: 'Molotov', price: 400 },
        { id: 'incgrenade', name: 'Incendiary', price: 600 },
        { id: 'decoy', name: 'Decoy', price: 50 },
    ],
    gear: [
        { id: 'vest', name: 'Kevlar Vest', price: 650 },
        { id: 'vesthelm', name: 'Kevlar + Helmet', price: 1000 },
        { id: 'defuser', name: 'Defuse Kit', price: 400 },
        { id: 'taser', name: 'Zeus x27', price: 200 },
    ]
};
